// extracted by mini-css-extract-plugin
export default {"leftShadow":"_4eurXfvv92f6GYhoE6EA","rightShadow":"DwXLt2No8xooRnJivUb1","placeHolderShimmer":"cF046TYa17JaCl_o6Z7o"};